export const mutations = {
  setCatagories: function (state, categories) {
    state.categories = [...categories];
  },
  setDocChecklist: function (state, doc) {
    state.docCheckList = doc;
  },

  setDisableBTN: function (state, { btn1, btn2 }) {
    state.disableBtn = btn1;
    state.disableBtn2 = btn2;
  },
};
